export default {
  name: 'marking--markingStatus',
};